/**
 * Character set allowed in invoice address lines: letters, digits,
 * whitespace, and a small set of punctuation (# - / ,) that real addresses
 * commonly need. Duplicated in 3 callers before extraction — keep them in
 * sync via these shared constants.
 *
 *   - INVOICE_ADDRESS_REGEX         — required field (1+ chars must match)
 *   - INVOICE_ADDRESS_REGEX_OPTIONAL — optional field (empty string allowed)
 */
export const INVOICE_ADDRESS_REGEX = /^[A-Za-z0-9\s#\-/,]+$/;
export const INVOICE_ADDRESS_REGEX_OPTIONAL = /^[A-Za-z0-9\s#\-/,]*$/;

export interface InvoiceFormDetails {
    companyName?: string;
    trn?: string;
    address1?: string;
    address2?: string;
    city?: string;
    countryBilling?: string;
}

export interface InvoicingAddress {
    name?: string;
    trn?: string;
    street: string;
    complement?: string;
    city: string;
    countryCode?: string;
}

/**
 * Customer `invoicingAddress` for PUT /customers/{id}, or undefined when the
 * checkout invoice form has no street or city.
 *
 * The API requires both whenever `invoicingAddress` is sent, and opening the
 * invoice section pre-fills the country alone — sending that rejected the
 * whole customer update with a 400.
 */
export const buildInvoicingAddress = (
    details?: InvoiceFormDetails | null
): InvoicingAddress | undefined => {
    const street = details?.address1?.trim();
    const city = details?.city?.trim();
    if (!street || !city) return undefined;
    return {
        name: details?.companyName,
        trn: details?.trn,
        street,
        complement: details?.address2,
        city,
        countryCode: details?.countryBilling,
    };
};
